import axios from "axios";
import Utils from "../Utility/Utils";
import DataService from "../DataService/DataService";
import RegionAVGGraph from "./RegionAverageGraph";
import CountryScoreCard from "./CountryScoreCard";
import gsap from "gsap";
import SubPage from "../SubPage";



export default class CountryPanel {
    constructor(data, worldMap) {
        this.countryDetailPanel = document.querySelectorAll('.experience .countryDetailPanel')
        this.panelListBtns = null
        this.worldMap = worldMap
        this.regionDropDown = window.innerWidth <= 992 ? $('.experience .mobile_slider_container #selectRegion') : $('.experience .left_detail_panel #selectRegion')
        this.regionPara = document.querySelector('.experience .left_detail_panel .region_para')
        this.countryScoreCard = null
        this.fetchedData = data;
        this.dataDescription = null

        this.init()
    }

    init() {
        if (!this.regionDropDown) {
            console.error("Dropdown element not found!");
            return;
        }

        this.regionDropDown.on('focus', () => {
            this.regionDropDown.find('.text').css('opacity', 0)
        })

        this.regionDropDown.on('focusout', () => {
            this.regionDropDown.find('.text').css('opacity', 1)
        })

        const uniqueRegions = Array.from(new Set(this.fetchedData.map(d => d.Region)));
        this.addCountryDropdown(uniqueRegions); // Populate the dropdown

        const avgGraphArea = document.querySelector('.experience .left_detail_panel .avg-graph')
        this.regionAVGGraph = new RegionAVGGraph(avgGraphArea, this.fetchedData)

        this.regionDropDown
            .dropdown({
                onChange: (value, text, $selectedItem) => {
                    this.updateLeftPanel(value);
                    this.updateRightPanel(value)

                    if (this.worldMap) {
                        this.worldMap.zoomToRegion(value)
                    }
                }
            })


        if(this.fetchedData){
            this.countryScoreCard = CountryScoreCard.getInstance(this.fetchedData)
        }

    }




    showCountryPanel() {
        this.countryDetailPanel.forEach(panel => panel.classList.add('active'))
    }

    hideCountryPanel() {
        this.countryDetailPanel.forEach(panel => panel.classList.remove('active'))
    }



    // Dynamically add countries to the dropdown
    addCountryDropdown(data) {
        if (!data || !Array.isArray(data)) {
            console.error('Invalid data format for dropdown population:', data);
            return;
        }


        data.sort((a, b) => {
            if (a.toLowerCase() < b.toLowerCase()) return -1;
            if (a.toLowerCase() > b.toLowerCase()) return 1;
            return 0; 
        });

        data.forEach((region) => {
            this.regionDropDown.find('.menu').append(`<div class="item" data-value="${region}">${region}</div>`)
        });
    }

    async updateLeftPanel(region) {
        const leftDetailPanel = document.querySelector('.experience .left_detail_panel');
        this.regionDropDown.dropdown('set selected', region);
        
        // Update the region title
        leftDetailPanel.querySelector('.region_title').textContent = Utils.toTitleCase(region);
    
        try {
            // Wait for the description to be fetched
            this.dataDescription = await DataService.fetchDescription();
            
            // Filter the description for the selected region
            const regionDescription = this.dataDescription.find(d => d.Region === region);
            
            // Check if description is found
            if (regionDescription) {
                this.regionPara.textContent = regionDescription.Description; // Assuming 'Description' is the property name
            } else {
                this.regionPara.textContent = 'No description available for this region.';
            }
    
        } catch (err) {
            console.error("Failed to fetch description:", err.message);
            this.regionPara.textContent = 'Error loading region description. Please try again later.';
        }
    
        // Update the region average graph
        this.regionAVGGraph.updateGraph(region);
    }
    

    updateRightPanel(region, country = null) { 

        const rightDetailPanel = document.querySelector('.experience .right_detail_panel')
        const countryList = rightDetailPanel.querySelector('.countryList')
        const leftCountryName = rightDetailPanel.querySelector('.context .small_para')
        leftCountryName.textContent = region + ' Countries'
        countryList.innerHTML = ""
        // You can now use this.fetchedData here without fetching again
        const regionData = this.fetchedData.filter(d => d.Region === region);
        regionData.forEach((region, i) => {
            // Extract integer and decimal parts of Total
            const total = parseFloat(Utils.roundUpToDecimal(region.Total, 1)) // Ensures one decimal place
            const integerPart = parseInt(Utils.roundUpToDecimal(region.Total, 1)); // Gets the part before the decimal
            const decimalPart = parseInt(Utils.extractDecimalDigit(total, 1));

            const list = `
                <li class="countryItem ${region.Country == country ? 'active' : ''}" data-target="${Utils.modifyText(region.Country)}">
                    <div class="card">
                        <div class="contry_title">
                            <img src="assets/images/Flags/${region.Flag}" alt="" class="flag">
                            <h3 class="generic_title">${region.Country}</h3>
                        </div>

                        <div class="countryScore">
                            <div class="point-block">
                                <p class="third_title">$</p>
                                <h3 class="point">${integerPart}</h3>
                                <p class="decimal">.${decimalPart}</p>
                            </div> 

                            <button class="deepDiveBtn" data-country="${region.Country}">
                                <p class="paragraph">Deep dive</p>
                                <svg width="22" height="12" viewBox="0 0 22 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M20.9988 5.99993L16.4295 10.5692M20.9988 5.99993L16.4295 1.43066M20.9988 5.99993H7.77042H1.15625" stroke="white" stroke-width="1.21847" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </button>
                        </div>
                    </div>
                </li>
            `

            countryList.innerHTML += list;
            const activeLi = countryList.querySelector('.active');

            

            if (activeLi) {
                // Calculate the position of the active <li> relative to the <ul> container
                const liPosition = activeLi.offsetTop;

                // Optionally, add an offset for visual spacing (e.g., centering the item)
                const offset = (countryList.clientHeight / 2) - (activeLi.clientHeight / 2);

                // Scroll the <ul> container manually
                countryList.scrollTop = liPosition - offset;
            }

            //HANDLE CLICK ON DEEP DIVE BTNS
            this.panelListBtns = document.querySelectorAll('.experience .countryDetailPanel .countryList .deepDiveBtn')
            this.panelListBtns.forEach(btn => {
                btn.addEventListener('click', () => {
                    SubPage.getInstance().showCountryScoreCardPage();
                    this.isPortrait ? SubPage.handleMobileActiveState(1) : SubPage.handleActiveState(2)
                    if (this.countryScoreCard != null) {
                        this.countryScoreCard.updateCountryScore(btn.dataset.country)
                    }
                })
            })
 
            
        })

        const countryListItems = document.querySelectorAll('.countryList .countryItem')

        
        countryListItems.forEach(btn => {
            btn.addEventListener("mouseover", () => {
                const target = btn.dataset.target.toLowerCase()
                const activeEl = document.querySelector(".countrygroup.active");
                if (activeEl) {
                    activeEl.classList.remove("active")
                }
                document.querySelector(`.countrygroup#${target}`).classList.add("active")
            })

            btn.addEventListener("mouseout", () => {
                const activeEl = document.querySelector(".countrygroup.active");
                if (activeEl) {
                    activeEl.classList.remove("active")
                }
            })
        })
    }
}
